// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"91ca8aab","453":"6c9e7e49"}[chunkId] + ".chunk.js";
};